import React from 'react';
import styled from 'astroturf/react';

import TopSection from './TopSection';
import SubtopicsBar from './SubtopicsBar';
import SubtopicSection from './SubtopicSection';
import BottomSection from './BottomSection';

import { Props as Subtopic } from './SubtopicSection';

export interface Props {
  name: string;
  numCourses: number;
  imageUrls: [string, string, string];
  subtopics: Array<Subtopic>;
  isLoggedIn?: boolean;
}

const Background = styled.div`
  background: white;
`;

const Container = styled.div`
  max-width: 1130px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 16px;
`;

const TopicMarketingPage: React.FunctionComponent<Props> = ({
  name,
  numCourses,
  imageUrls,
  subtopics,
  isLoggedIn,
}) => {
  const subtopicSections = subtopics.map((subtopic) => (
    <SubtopicSection key={subtopic.id} {...subtopic} />
  ));
  return (
    <Background>
      <TopSection
        name={name}
        numCourses={numCourses}
        showSignUpButton={!isLoggedIn}
        imageUrls={imageUrls}
      />
      <Container>
        <SubtopicsBar subtopics={subtopics} />
        {subtopicSections}
      </Container>
      <BottomSection />
    </Background>
  );
};

export default TopicMarketingPage;
